export const convertPersianNumbers = (input: string): string => {
  if (!input) return "";
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  let output = input;
  for (let i = 0; i < 10; i++) {
    output = output.replace(persianNumbers[i], englishNumbers[i]);
    output = output.replace(arabicNumbers[i], englishNumbers[i]);
  }
  return output;
};

export const convertToPersianDigits = (input: string): string => {
  if (!input) return "";
  const englishNumbers = [
    /0/g,
    /1/g,
    /2/g,
    /3/g,
    /4/g,
    /5/g,
    /6/g,
    /7/g,
    /8/g,
    /9/g,
  ];
  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  let output = input;
  for (let i = 0; i < 10; i++) {
    output = output.replace(englishNumbers[i], persianNumbers[i]);
    output = output.replace(arabicNumbers[i], persianNumbers[i]);
  }
  return output;
};

